export default {
  /**
   * 고객
   */
   REJECT_ACCEPT_EMAIL : "/reject",  // 이메일 수신 거부

   /**
    * 캠페인
    */
   CAMPAIGN_TRACKING_WITH_LONG_KEY : "/cl",  // 캠페인 트래킹 (암호화 파라미터 정보)
   CAMPAIGN_TRACKING_WITH_SHORT_KEY : "/cs",  // 캠페인 트래킹 (짧은 URL 정보)

   KAKAO_LOGOUT:"/kakaoLogout",   //카카오 로그아웃
   CUSTOMER_SIGNUP:"/signup",     //회원가입
   TERMS_DETAIL:"/terms/:termsCode",     //약관 상세

   IDENTIFY_RESPONSE:"/identifyResponse",    //본인인증
   IDENTIFY_REQUEST:"/identifyRequest",    //본인인증

   /* 쿠폰 바코드 조회 */
  OFFER_CONFIRM: "/ofercnfirm",
  OFFER_CONFIRM_SHORT: "/cp",

  COUPON : "/coupon",
  COUPON_DETAIL : "/coupon/:couponMstId"

};